<template>
  <ajax-select
    v-if="hasAnyPermission('OBJECT_VIEW')"
    v-bind="$attrs"
    :label="displayedLabel"
    resource-url="objects"
    :value="objectId"
    @update:value="$emit('update:objectId', $event)"
  >

  </ajax-select>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import AjaxSelect from '@/components/AjaxSelect';
import {MainUtils} from '@/utils/main-utils';

export default {
  name: 'SelectObject',
  components: {AjaxSelect},
  mixins: [
    LocaleUtils,
    MainUtils
  ],
  props: {
    objectId: {
      default () {
        return null;
      }
    },
    label: {
      type: String
    }
  },
  computed: {
    displayedLabel () {
      return this.label ?? this.transc('object.object', 1);
    }
  }
}
</script>
